import script from "./customer-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-bar.vue?vue&type=script&setup=true&lang=js"

import "./customer-bar.vue?vue&type=style&index=0&id=e1cc4d60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1cc4d60"]])

export default __exports__